import { createContext } from 'react'

export const MainContext = createContext({
  user: {},
  setUser: () => {},
  selectedTerm: {},
  setSelectedTerm: () => {},
  reimbursement: {},
  setReimbursement: () => {},
  reimbursementItem: {},
  setReimbursementItem: () => {},
  receiptFiles: {},
  setReceiptFiles: () => {},
})
